import TableUser from './TableUsers'

export default TableUser



// WEBPACK FOOTER //
// ./src/views/Users/components/TableUsers/index.js